export default __webpack_public_path__ + "static/Branching_Default-2ad6db35aa6b3503eaad7f8c3bd13e36.png";